var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":_vm.modalId,"size":"sm","centered":"","ok-title":"OK","ok-only":"","title":_vm.title},on:{"ok":_vm.action}},[_c('p',[_vm._v(_vm._s(_vm.subTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }